import styled from 'styled-components';

import {
  StatusBanner as BreweryStatusBanner,
  StatusBannerAutoHide,
} from '@xing-com/banner';
import { Button } from '@xing-com/button';
import { IconDragAndDrop } from '@xing-com/icons';
import { mediaSmallOrTiny, zIndexSheet } from '@xing-com/layout-tokens';
import {
  spaceS,
  spaceM,
  spaceL,
  spaceXL,
  space3XL,
  cornerRadiusXL,
  xdlColorBackgroundTertiary,
  xdlColorTextSecondary,
  xdlColorBorder,
  xdlColorBorderStrong,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const UploadWrapper = styled.div<{ $isDraggingFile: boolean }>`
  display: flex;
  border-radius: ${cornerRadiusXL};
  border: 1px dashed ${xdlColorBorder};
  padding: ${space3XL} ${spaceXL};
  width: 100%;
  align-items: center;
  border-color: ${({ $isDraggingFile }) =>
    $isDraggingFile ? xdlColorBorderStrong : xdlColorBorder};
  background: ${({ $isDraggingFile }) =>
    $isDraggingFile ? xdlColorBackgroundTertiary : 'none'};

  @media ${mediaSmallOrTiny} {
    flex-direction: column;
    padding: ${spaceL};
    align-items: flex-start;
    gap: ${spaceS};
  }
`;

export const StyledIcon = styled(IconDragAndDrop)`
  flex-shrink: 0;

  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  margin-left: ${spaceM};
  margin-right: ${spaceXL};

  @media ${mediaSmallOrTiny} {
    margin: 0;
  }
`;

export const UploadCopy = styled(BodyCopy)`
  @media ${mediaSmallOrTiny} {
    margin-bottom: 0;
  } 
`;

export const FileFormatTip = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};

  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;

export const FileFormatTipMobile = styled(FileFormatTip)`
display: none;

  @media ${mediaSmallOrTiny} {
    display: block;
  }
`;

export const UploadButton = styled(Button)`
  flex-shrink: 0;

  @media ${mediaSmallOrTiny} {
    width: 100%;
  }

  &:hover::after {
    transform: none;
  }
`;

export const AriaMessage = styled.div`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const ErrorBanner = styled(BreweryStatusBanner)`
  margin-top: ${spaceXL};
`;

export const StatusBanner = styled(StatusBannerAutoHide)`
  z-index: ${zIndexSheet};
`;
